/**
 * 이미지 압축 유틸리티
 * 프로젝트 규칙: 썸네일 350x350, WebP, quality 65% (~20KB)
 */
export const compressImage = (file, maxSize = 350, quality = 0.65) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = maxSize;
      canvas.height = maxSize;
      const ctx = canvas.getContext('2d');

      // 중앙 크롭 후 리사이즈
      const size = Math.min(img.width, img.height);
      const sx = (img.width - size) / 2;
      const sy = (img.height - size) / 2;
      ctx.drawImage(img, sx, sy, size, size, 0, 0, maxSize, maxSize);

      canvas.toBlob((blob) => {
        resolve(new File([blob], file.name.replace(/\.\w+$/, '.webp'), { type: 'image/webp' }));
      }, 'image/webp', quality);
    };
    img.src = URL.createObjectURL(file);
  });
};

/**
 * 상세 이미지 압축 (비율 유지, 최대 너비 제한)
 * 원본 비율 유지하며 maxWidth 이내로 리사이즈
 */
export const compressDetailImage = (file, maxWidth = 1000, quality = 0.75) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let w = img.width;
      let h = img.height;
      if (w > maxWidth) {
        h = Math.round((h * maxWidth) / w);
        w = maxWidth;
      }
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob((blob) => {
        resolve(new File([blob], file.name.replace(/\.\w+$/, '.webp'), { type: 'image/webp' }));
      }, 'image/webp', quality);
    };
    img.src = URL.createObjectURL(file);
  });
};
